import React, { createContext, useState, useContext, ReactNode, Dispatch, SetStateAction } from 'react';

interface DataState {
    [key: string]: any;
}
interface DataStates {
  flag1: any;
  flag2: any;
  // Add more flags as needed
}
interface BooleanState {
  [key: string]: boolean;
}

interface DataContextType {

  invoicingInformation:DataState,
setinvoicingInformation:Dispatch<SetStateAction<DataState>>;
    dataall: DataState;
    setData: Dispatch<SetStateAction<DataState>>;
    Trailerstore: DataState;

   
    
    tokenresponse :DataState,
    setaccesstoken:Dispatch<SetStateAction<DataState>>;




    downLoad_load : DataState;
    setdownLoad_load:Dispatch<SetStateAction<DataState>>;

    load:DataState;
    setLoad: Dispatch<SetStateAction<DataState>>;


    stor_carrier_data:DataState;
     setstor_carrier_data: Dispatch<SetStateAction<DataState>>;

    SetTrailer: Dispatch<SetStateAction<DataState>>;
    storepassword: DataState;
    setpassword: Dispatch<SetStateAction<DataState>>;
    trailerdata: DataState;
    settruckalldata: Dispatch<SetStateAction<DataState>>;

    truckalldata: DataState;
    settrailerdata: Dispatch<SetStateAction<DataState>>;

    truckApiResponse:any
    settruckApiResponse:Dispatch<SetStateAction<any>>;


    truckFinanceApiResponse:any,
    settruckFinanceApiResponse:Dispatch<SetStateAction<any>>;

    DriverDocumentsApiResponse:any,
    setDriverDocumentsApiResponse:Dispatch<SetStateAction<any>>;

    DriversafetysApiResponse:any,
    setsefetyDocumentsApiResponse:Dispatch<SetStateAction<any>>;

    DrivertaxApiResponse:any,
    setDrivertaxApiResponse:Dispatch<SetStateAction<any>>;

    get_true_false: BooleanState;
    set_true_false: Dispatch<SetStateAction<BooleanState>>;
    
}

const DataContext = createContext<DataContextType | undefined>(undefined);

interface CreateContextServiceProps {
     children: ReactNode;
}

const CreateContextService: React.FC<CreateContextServiceProps> = ({ children }) => {

  // >>>>>>>>>>>>>> Assert data store
   const [dataall, setData] = useState<DataState>({});
    const [Trailerstore, SetTrailer] = useState<DataState>({});
    const [storepassword, setpassword] = useState<DataState>({});
    const [truckalldata, settruckalldata] = useState<DataState>({});
    const [trailerdata, settrailerdata] = useState<DataState>({});
     // >>>>>>>>>>>>>> Assert data store


// not use this store data
     const [truckApiResponse, settruckApiResponse] = useState<DataState>({});
     const [truckFinanceApiResponse, settruckFinanceApiResponse] = useState<DataState>({});
     const[DriverDocumentsApiResponse ,setDriverDocumentsApiResponse] =useState<DataState>({});
     const[DriversafetysApiResponse ,setsefetyDocumentsApiResponse] =useState<DataState>({});
     const[DrivertaxApiResponse ,setDrivertaxApiResponse] =useState<DataState>({});
// not use this store data


// >>>>>>>>>>>>.partner data store
const[invoicingInformation ,setinvoicingInformation] =useState<DataState>({});
const [load ,setLoad]=useState<DataState>({});

const [downLoad_load ,setdownLoad_load]=useState<DataState>({});

const [tokenresponse ,setaccesstoken]=useState<DataState>({});

const [stor_carrier_data ,setstor_carrier_data]=useState<DataState>({});

const [get_true_false, set_true_false] = useState<BooleanState>({});








  return (
    <DataContext.Provider value={{ dataall, setData ,Trailerstore, SetTrailer ,storepassword,setpassword,
     get_true_false, set_true_false , stor_carrier_data ,setstor_carrier_data ,tokenresponse ,setaccesstoken  , downLoad_load ,setdownLoad_load , load ,setLoad ,truckalldata,settruckalldata,truckApiResponse,
     settruckApiResponse,truckFinanceApiResponse,settruckFinanceApiResponse ,DriverDocumentsApiResponse ,setDriverDocumentsApiResponse,
     invoicingInformation ,setinvoicingInformation ,DriversafetysApiResponse ,setsefetyDocumentsApiResponse, DrivertaxApiResponse ,setDrivertaxApiResponse,trailerdata, settrailerdata}}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = (): DataContextType => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('UseData must be used within a CreateContextService');
  }
  return context;
};

export default CreateContextService;